'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BarHeader = function BarHeader(props) {
    var title = props.title,
        subtitle = props.subtitle,
        theme = props.theme;


    if (!theme) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: theme.headerWrapper },
        _react2.default.createElement(
            'div',
            { className: theme.title },
            title
        ),
        subtitle && _react2.default.createElement(
            'div',
            { className: theme.subtitle },
            subtitle
        ),
        _react2.default.createElement('div', { className: theme.bottomBorder })
    );
};

exports.default = BarHeader;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/lib/BarHeader/index.js
// module id = 852
// module chunks = 4 5 8 9 14